import React, { Component } from 'react';
import PropTypes from 'prop-types';

class IconDynamic extends Component {
    static propTypes = {
        /** Контент */
        children: PropTypes.node,
    };

    render() {
        const { children, ...iconDynamicProps } = this.props;

        return (
            <span className="bloko-icon-dynamic" {...iconDynamicProps}>
                {children}
            </span>
        );
    }
}

export default IconDynamic;
